<template>
  <div>
    <el-form :model="query" ref="queryForm" :inline="true">
      <el-form-item label="订单类型：">
        <el-select v-model="query.type" placeholder="全部" clearable size="small">
          <el-option label="全部" :value="undefined" />
          <el-option v-for="(item, key) in orderTypeMap" :key="key" :label="item.label" :value="item.value" />
        </el-select>
      </el-form-item>
      <el-form-item label="订单编号：">
        <el-input v-model="query.ordernum" placeholder="请输入订单编号" clearable size="small" />
      </el-form-item>
      <el-form-item label="下单人：">
        <el-input v-model="query.nameorpho" placeholder="请输入姓名/手机号" clearable size="small" />
      </el-form-item>
      <el-form-item label="支付方式：">
        <el-select v-model="query.payType" placeholder="全部" clearable size="small">
          <el-option label="支付宝" :value="1" />
          <el-option label="微信支付" :value="2" />
          <el-option label="支付凭证" :value="3" />
          <el-option label="银行卡" :value="4" />
          <el-option label="组合现金支付" :value="0" />
        </el-select>
      </el-form-item>
      <el-form-item label="业务信息：">
        <el-input v-model="query.ywName" placeholder="请输入姓名/手机号" clearable size="small" />
      </el-form-item>
      <el-form-item label="大区信息：">
        <el-input v-model="query.areaName" placeholder="请输入姓名/手机号" clearable size="small" />
      </el-form-item>
      <el-form-item label="下单人身份：">
        <el-select v-model="query.levelId" placeholder="请选择" clearable size="small">
          <el-option :label="it.name" :value="it.level" v-for="it in fetchList" :key="it.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="订单状态：">
        <el-select v-model="query.state" placeholder="全部" clearable size="small">
          <el-option label="全部" :value="undefined" />
          <el-option label="已支付" :value="1" />
          <el-option label="已取消" :value="2" />
        </el-select>
      </el-form-item>
      <el-form-item label="客户状态：">
        <el-select v-model="query.isOneselfDeveloped" placeholder="全部" clearable size="small">
          <el-option label="全部" :value="undefined" />
          <el-option label="开发客户" :value="1" />
          <el-option label="继承客户" :value="0" />
        </el-select>
      </el-form-item>
      <el-form-item label="下单时间：">
        <el-date-picker v-model="dateTime" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
      </el-form-item>
      <el-form-item label="支付成功时间：">
        <el-date-picker v-model="payTime" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleDownload" size="mini">导出</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import goodsOrderApi from '@/api/order/goodsOrder'
import { filterEmpty } from '@/utils'
import OrderPerformanceApi from '@/api/order/OrderPerformance'
import enums from '@/utils/enums'
import { parsePerformanceFilters, performanceFilters } from '@/utils/orderPerformance'
export default {
  data() {
    return {
      dateTime: [],
      payTime: [],
      list: [],
      total: 0,
      listLoading: true,
      query: {},
      fetchList: []
    }
  },
  watch: {
    '$route.query': {
      immediate: true,
      deep: true,
      handler(query) {
        if (query.code !== 'OrderPerformanceExport') return
        this.query = parsePerformanceFilters(query.performanceFilters || query.cashQuery)
        this.query.timeType = 0
        this.dateTime = this.query.startTime && this.query.endTime ? [this.query.startTime, this.query.endTime] : []
        this.payTime = this.query.payStartTime && this.query.payEndTime ? [this.query.payStartTime, this.query.payEndTime] : []
      }
    }
  },
  created() {
    this.query = parsePerformanceFilters(this.$route.query.performanceFilters || this.$route.query.cashQuery)
    this.query.timeType = 0
    this.dateTime = this.query.startTime && this.query.endTime ? [this.query.startTime, this.query.endTime] : []
    this.payTime = this.query.payStartTime && this.query.payEndTime ? [this.query.payStartTime, this.query.payEndTime] : []
    this.getFetchList()
  },
  computed: {
    orderTypeMap() {
      return enums.getOrderType()
    }
  },
  methods: {
    getFetchList() {
      goodsOrderApi.fetchList({}).then((data) => {
        this.fetchList = data.data;
      })
    },
    handleDownload() {
      this.query.startTime = this.dateTime && this.dateTime.length > 0 ? this.dateTime[0] : undefined
      this.query.endTime = this.dateTime && this.dateTime.length > 0 ? this.dateTime[1] : undefined
      this.query.payStartTime = this.payTime && this.payTime.length > 0 ? this.payTime[0] : undefined
      this.query.payEndTime = this.payTime && this.payTime.length > 0 ? this.payTime[1] : undefined
      this.query.timeType = 0
      return this.$common.confirm('是否确认导出')
        .then(() => OrderPerformanceApi.orderPerformanceExport(filterEmpty(performanceFilters(this.query)))).then((res) => {
          if (res.code === '0') {
            setTimeout(() => {
              this.$emit('created')
            }, 1000)

          }
        })
    },

  }

}
</script>

<style>
</style>
